export const modalConstants = {
  SHOWMODAL: "SHOWMODAL",
  HIDDENMODAL: "HIDDENMODAL",
  LOADING: "LOADING",
  RESET: "RESET",
  UPDATEMODAL: "UPDATEMODAL",
  FAILURE: "FAILURE",
  SUCCESS: "SUCCESS"
};
